import { render } from "./NetworkError.vue?vue&type=template&id=1046c7b6&scoped=true"
const script = {}

import "./NetworkError.vue?vue&type=style&index=0&id=1046c7b6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1046c7b6"]])

export default __exports__